import React, { useContext } from 'react'
import { imgApiUrl } from '../../../lib/constants'
import Button from '../../../UIComponents/Button'
import Image from 'next/dist/client/image'
import { DataProps } from '../../Blogs/BlogsSection'
import Link from 'next/link'
import { MainContext } from '../../../contexts/MainContext'

const BlogSection = (props: { blog: DataProps }) => {
	const { setIsLoading } = useContext(MainContext)
	const handleClick = (e: any) => {
		if (!(e.ctrlKey || e.metaKey)) {
			setIsLoading(true)
		}
	}
	return (
		<Link href={`blog/${props?.blog?.slug}`}>
			<a>
				<div onClick={handleClick}>
					<div className='blog bg-gray-100 shadow-lg p-3 text-center flex flex-col items-center rounded-lg'>
						<div className='img relative w-full overflow-hidden rounded-lg' style={{ position: 'relative', width: '100%', paddingBottom: '53.58%' }}>
							<Image
								layout='fill'
								style={{
									objectFit: 'cover'
								}}
								src={`${imgApiUrl?.blog}/${props?.blog?.image}`}
								alt={props?.blog?.name}
								priority={true}
							/>
						</div>
						<h1 className='font-semibold text-black text-center text-xl mt-4 h-16 flex items-center'>{props?.blog?.name?.substring(0, 40)} ...</h1>
						<p className='mt-2 text-gray-600 leading-normal h-[75px] lg:h-auto'>{props?.blog?.short_content?.substring(0, 60)} ...</p>
						<div className='post-date mt-2 text-[15px]'>{props?.blog?.publish_date}</div>
						<Button aria-label='click here to read blog details' text='Read More' link={`blog/${props?.blog?.slug}`} classpara='dark-blue-bg read-more-btn' />
					</div>
				</div>
			</a>
		</Link>
	)
}

export default BlogSection
